import { render } from "./TemplateZones.vue?vue&type=template&id=4f19a2c1&scoped=true"
import script from "./TemplateZones.vue?vue&type=script&lang=js"
export * from "./TemplateZones.vue?vue&type=script&lang=js"

import "./TemplateZones.vue?vue&type=style&index=0&id=4f19a2c1&lang=less&scoped=true"

import exportComponent from "/builds/cloudstack/keycloak-auth/.cloudstack-src/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f19a2c1"]])

export default __exports__